














import { Component, Prop, Ref, Vue, Watch } from "vue-property-decorator";

@Component({
  components: {}
})
export default class GenerateSoap extends Vue {
  @Prop() kodeSoap!: string;

  generate(kode) {
    this.$emit("generateSoap", kode);
  }

  viewTombol(kode) {
    if (kode == "S") {
      return "Generate Subjective dari Asesmen Awal";
    } else if (kode == "O") {
      return "Generate Objective dari Asesmen Awal";
    } else if (kode == "A") {
      return "Generate Assesment dari Asesmen Awal";
    } else if (kode == "P") {
      return "Generate Plan dari Asesmen Awal";
    }
    {
      return "Generate Semua dari Asesmen Awal";
    }
  }
}
